import {ReactElement} from "react";

const Star: () => ReactElement = (): ReactElement => <div className="grid-item grid-star"></div>

export default Star;